import { Table } from "antd";
import React, { memo, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createNoticeSettings } from "../../store/actions/actions";
import { useRouteMatch } from "react-router";
import tableColumns from "../../utils/tableColumns";

const DebtorsList = memo(({ withoutSelection, noticeTypeView }) => {
	const dispatch = useDispatch();
	const {
		params: { noticeId, fileId },
	} = useRouteMatch("/Debts/file/:fileId/notice/:noticeId") || {
		params: {},
	};

	const debtorStates = useSelector((store) => store.debtsStore.debtorStates);
	const debtors = useSelector((store) => store.debtsStore.debts);
	const createNoticeDebtors = useSelector(
		(store) => store.debtsStore.createNotice.debtors
	);
	const debtorsListLoading = useSelector(
		(store) => store.debtsStore.debtsListLoading
	);

	const [pageSize, setPageSize] = useState();
	const [activeFilters, setActiveFilters] = useState({});

	const selectedDebtors = useMemo(
		() => createNoticeDebtors || [],
		[createNoticeDebtors]
	);
	const columns = useMemo(
		() => tableColumns(noticeId, noticeTypeView, debtorStates),
		[noticeId, noticeTypeView, debtorStates]
	);
	const filteredDebtors = useMemo(
		() =>
			columns.reduce((filteredRecords, column, index) => {
				const columnKey = column.key || column.dataIndex || index;
				const filterValues = activeFilters[columnKey];

				if (!filterValues?.length || !column.onFilter) {
					return filteredRecords;
				}

				return filteredRecords.filter((record) =>
					filterValues.some((value) => column.onFilter(value, record))
				);
			}, debtors),
		[activeFilters, columns, debtors]
	);

	const rowSelection = {
		selectedRowKeys: selectedDebtors,
		onChange: (selectedRowKeys) => {
			dispatch(createNoticeSettings({ debtors: selectedRowKeys }));
		},
		onSelectAll: (e) => {
			if (e) {
				dispatch(
					createNoticeSettings({
						debtors: filteredDebtors.map((debtor) => debtor.id),
					})
				);
			} else {
				dispatch(createNoticeSettings({ debtors: [] }));
			}
		},
	};

	const pagination = {
		pageSize,
		showSizeChanger: true,
		onShowSizeChange: (_current, pageSize) => setPageSize(pageSize),
		pageSizeOptions: ["10", "30", "50", "100"],
		total: debtors.length,
		showTotal: (total) => `Задолженностей: ${selectedDebtors.length}/${total}`,
	};

	return (
		<Table
			key={`${fileId} ${noticeId}`}
			loading={debtorsListLoading}
			columns={columns}
			dataSource={debtors}
			rowSelection={withoutSelection ? undefined : rowSelection}
			rowKey={(row) => row.id}
			pagination={pagination}
			onChange={(_pagination, filters) => setActiveFilters(filters)}
		></Table>
	);
});

export default DebtorsList;
